import theme, { ThemeVariants } from '@theme';
import React from 'react';
import styled from 'styled-components';

interface SubTitleProps {
  color: ThemeVariants;
  display: string;
}

const SubTitle: React.FC<SubTitleProps> = ({ color, display }) => (
  <SubTitleContainer>
    <ColoredSquare color={color} />
    <DisplaySubTitle>{display}</DisplaySubTitle>
  </SubTitleContainer>
);

const getColor = (color: ThemeVariants) => {
  return theme.palette[color][300];
};

const SubTitleContainer = styled.div`
  width: 100%;
  height: 1rem;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-bottom: 0.25rem;
`;

interface ColoredSquareProps {
  color: ThemeVariants;
}

const ColoredSquare = styled.div<ColoredSquareProps>`
  width: 0.5rem;
  height: 0.5rem;
  border-width: 0px;
  border-radius: 0.125rem;
  background-color: ${({ color }) => getColor(color)};
`;

const DisplaySubTitle = styled.span`
  font-size: 0.688rem;
  line-height: 1rem;
  font-weight: 500;
  color: ${theme.palette.grey[800]};
  margin-left: 0.625rem;
`;

export default SubTitle;
